export const isLogin = (store) => {
  return store.auth.isLogin;
};
export const userData = (store) => {
  return store.auth;
};
